import { render, staticRenderFns } from "./report-more.vue?vue&type=template&id=b7a4a150&scoped=true"
import script from "./report-more.vue?vue&type=script&lang=js"
export * from "./report-more.vue?vue&type=script&lang=js"
import style0 from "./report-more.vue?vue&type=style&index=0&id=b7a4a150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a4a150",
  null
  
)

export default component.exports